// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__XFRAi","track":"ThemeToggle_track__4+tJq","dark":"ThemeToggle_dark__afs1d","thumb":"ThemeToggle_thumb__fM6oN"};